import { render } from "./Github.vue?vue&type=template&id=875c2814"
import script from "./Github.vue?vue&type=script&lang=js"
export * from "./Github.vue?vue&type=script&lang=js"
script.render = render

export default script